import { ProductCardData } from '../types';

// Products for Everyone Section Data
export const PRODUCTS_FOR_EVERYONE_DATA: ProductCardData[] = [
  {
    id: 'individuals',
    title: 'For <br />Individuals',
    subtitle:
      'For salaried, traders, investors, business professionals and freelancers.',
    description:
      'File your Income Tax Return (ITR) and get maximum refund with 100% accuracy.',
    link: '/filing?utmref=itr_2025_organic_CT_homepage',
    dataLabel: 'For Individuals',
    image: {
      webp: 'https://assets1.cleartax-cdn.com/cleartax/images/1620019995_1605863309_desktop_fold_productsforeveryone_card_individuals.webp',
      jpeg: 'https://assets1.cleartax-cdn.com/cleartax/images/1605863309_desktop_fold_productsforeveryone_card_individuals.png',
      alt: 'productsforeveryone',
    },
    hoverColor: 'bg-purple-300',
  },
  {
    id: 'tax-experts',
    title: 'For <br class="sm:hidden" />Tax Experts',
    subtitle: 'For tax experts and<br class="sm:hidden" />professionals.',
    description:
      'Explore how tax experts save 2-7% in taxes for their clients with our GST, ITR and TDS suite.',
    link: '/tax-experts',
    dataLabel: 'For Tax Experts',
    image: {
      webp: 'https://assets1.cleartax-cdn.com/cleartax/images/1620106405_1605872216_desktop_fold_productsforeveryone_card_taxexperts.webp',
      jpeg: 'https://assets1.cleartax-cdn.com/cleartax/images/1605872216_desktop_fold_productsforeveryone_card_taxexperts.png',
      alt: 'taxexpertproducforeveryone',
    },
    hoverColor: 'bg-orange-300',
  },
  {
    id: 'smes',
    title: 'For <br />SMEs',
    subtitle: 'For less than ₹50Cr<br class="sm:hidden" />turnover businesses.',
    description:
      'Explore SME suite including GST, Invoicing and TDS solution along with Clear app.',
    link: '/sme',
    dataLabel: 'For SMEs',
    image: {
      webp: 'https://assets1.cleartax-cdn.com/cleartax/images/1619783039_1605872581_desktop_fold_productsforeveryone_card_smes.webp',
      jpeg: 'https://assets1.cleartax-cdn.com/cleartax/images/1605872581_desktop_fold_productsforeveryone_card_smes.png',
      alt: 'smeproductforeveryone',
    },
    hoverColor: 'bg-green-250',
  },
  {
    id: 'enterprise',
    title: 'For <br />Enterprise',
    subtitle: 'For more than ₹50Cr <br/>turnover businesses.',
    description:
      'Explore enterprise-grade stack of GST, e-Invoicing, e-Waybill, Vendor solutions and more.',
    link: '/enterprise',
    dataLabel: 'For Enterprise',
    image: {
      webp: 'https://assets1.cleartax-cdn.com/cleartax/images/1619775001_1605872682_desktop_fold_productsforeveryone_card_enterprise.webp',
      jpeg: 'https://assets1.cleartax-cdn.com/cleartax/images/1605872682_desktop_fold_productsforeveryone_card_enterprise.png',
      alt: 'entproductforeveryone',
    },
    hoverColor: 'bg-blue-350',
  },
];
